import { GET_SHIPPING_LIST, GET_SHIPPING_BY_ID } from './ApiConstants';
import api from './ApiHandler';

export const getShippingsByPage = async (payload: any) => {
  return await api.get(GET_SHIPPING_LIST, { params: payload });
};

export const getShippingById = async (payload: any) => {
  return await api.get(GET_SHIPPING_BY_ID, { params: payload });
};
